import { useMutation } from "@tanstack/react-query";

import { TeacherClassesSendParentInvitesResponseBody } from "@seneca/class-service-types";

import { getClient } from "services";

import logError from "seneca-common/utils/sentry/logError";

export default function useBatchSendTeacherClassesParentInvites({
  onSuccess
}: {
  onSuccess: (
    data: TeacherClassesSendParentInvitesResponseBody | undefined
  ) => void;
}) {
  return useMutation(
    (classIds?: string[]) => {
      return getClient("classService").teacherClassesSendParentInvites({
        classIds
      });
    },
    {
      onSuccess,
      onError: error => {
        logError(error, {
          message:
            "Class service: failed to batch send teacher classes parent invites"
        });
      }
    }
  );
}
